// import React, { useState, useEffect, useLayoutEffect } from 'react'
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
// import _ from "lodash"
// import { v4 } from "uuid"
// import Swal from 'sweetalert2'
// import axiosConfig from '../config/axiosConfig'
// import { Card, CardDeck, Row, Col, Accordion, Button} from 'react-bootstrap'
// import BoxItemDropDown from '../components/BoxItemDropDown'
// import FeatherIcon from 'feather-icons-react';


// var checkVRN = false;
// var checkPAN = false;

// const headers = {
//     'Content-Type': 'application/json',
//     'APIkey': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
// }

// function MapButton(props) {
//     const BoxName = props.BoxName;


//     if (BoxName === 'Create Combination') {
//         return (

//             <Card.Footer>
//                 <Button className="w-35"
//                     variant="shell"
//                     onClick={() => mapCardsAPI(props)}
//                 >
//                     Save Combination</Button>
//             </Card.Footer>
//         )
//     }
//     return (
//         <>
//         </>
//     )
// }

// function mapCardsAPI(props) {

//     debugger
//     console.log('here safee')

//     let VRN = ""
//     let Cards = []
//     props.mappedData.map((el, index) => {
//         let type = el.id.split("-")
//         if (type[0] === 'card')
//             Cards.push(el.name)
//         else if (type[0] === 'vrn')
//             VRN = el.name
//     })
    
//     if(VRN != '')
//     {
//     axiosConfig.post('Portal/CardMapping', {
//         "UserBranchID": props.selectedBranchID,
//         "VRN": VRN,
//         "Cards": Cards
//     })
//         .then((res) => {
//             debugger
//             console.log(res.data)
//             if(res.data.responsecode = '00')
//             {
//             Swal.fire({
//                 icon: 'success',
//                 title: 'Card Mapping Submitted',
//                 text: res.data.status.description,
//                 position: 'top-end',
//                 timer: 1500
//             })

//             setTimeout(function() {
//                 props.onMapResult("Clear Mapping Data")
//             }, 1500);
//          window.location.reload();
//         }
//         else
//         {
//             Swal.fire({
//                 title: "Something Went Wrong",
//                 text: res.data.description,
//                 icon: 'error',
//                 confirmButtonText: 'Okay'
//             })
//         }
            
//         })
//         .catch(function (error) {
//             Swal.fire({
//                 title: "Something Went Wrong",
//                 text: error.response.data.errorMessage,
//                 icon: 'error',
//                 confirmButtonText: 'Okay'
//             })
//         })
//         .finally(() => {
//             //DND(props)
//             checkVRN = false
//             checkPAN = false
//         });
//     }
//     else 
//     {
//         Swal.fire({
//             title: "Please select combination",
//             text: "Please select VRN and CARD",
//             icon: 'error',
//             confirmButtonText: 'Okay'
//         })
//     }

// };
// // function mapCardsAPI(props) {


// //     console.log('here safee')

// //     let VRN = ""
// //     let Cards = []
// //     props.mappedData.map((el, index) => {
// //         let type = el.id.split("-")
// //         if (type[0] === 'card')
// //             Cards.push(el.name)
// //         else if (type[0] === 'vrn')
// //             VRN = el.name
// //     })

// //     axiosConfig.post('Portal/CardMapping', {
// //         "UserBranchID": props.selectedBranchID,
// //         "VRN": VRN,
// //         "Cards": Cards
// //     })
// //         .then((res) => {
// //             console.log(res.data)
// //             Swal.fire({
// //                 icon: 'success',
// //                 title: 'Card Mapping Submitted',
// //                 text: res.data.status.description,
// //                 position: 'top-end',
// //                 timer: 1500
// //             })

// //             setTimeout(function() {
// //                 props.onMapResult("Clear Mapping Data")
// //             }, 1500);

            
// //         })
// //         .catch(function (error) {
// //             Swal.fire({
// //                 title: "Something Went Wrong",
// //                 text: error.response.data.errorMessage,
// //                 icon: 'error',
// //                 confirmButtonText: 'Okay'
// //             })
// //         })
// //         .finally(() => {
// //             //DND(props)
// //             checkVRN = false
// //             checkPAN = false
// //         });

// // };

// function DND(props) {
//     const [totalVRN, setTotalVRN] = useState(0)
//     const [refreshMapping, setRefreshMapping] = useState(0)
//     const [counter, setCounter] = useState(props.TotalFee)
//     const [loading, setLoading] = useState(false);
//     const [UserData, setUserData] = useState([]);
//     const [selectedBranchID, setSelectedBranchID] = useState(props.data.selectedBranchId)
//     const [selectedBranchNumber, setSelectedBranchNumber] = useState(props.data.selectedBranchNumber)

//     const Swal = require('sweetalert2')
//     const [text, setText] = useState("")
//     const [state, setState] = useState({
//         "vrn": {
//             title: "Vehicles",
//             items: []
//         },
//         "cards": {
//             title: "Shell Cards",
//             items: []
//         },
//         "mapped": {
//             title: "Create Combination",
//             items: []
//         }
//     })

  

//     function clearMapping(data){

//         setState(prevState => {
//             return {
//                 ...prevState,
//                 "mapped": {
//                     title: "Create Combination",
//                     items: []
//                 }
//             }
//         })

//         setRefreshMapping(prevCount => prevCount + 1);
//         props.refreshCardMapping(refreshMapping)
//     }

//     function getCards(branchID) {
//         axiosConfig.post('Accounts/FetchAccountCards', {
//             "UserBranchID": branchID
//         }, {
//             headers: headers
//         })
//             .then((res) => {
//                 let cards = []
//                 for (var i = 0; i < res.data.cards.length; i++) {
//                     // let card = {
//                     //     id: 'card-' + v4(),
//                     //     name: res.data.cards[i].pan,
//                     //     driver: res.data.cards[i].driverName
//                     // }
//                     var str = res.data.cards[i].pan;
//                                         str = str.replace(str.substring(4,11), "****")
//                                         let card = {
//                                             id: 'card-' + v4(),
//                                             //name: res.data.cards[i].pan,
//                                             name: str,
//                                             driver: res.data.cards[i].driverName, 
//                                             vrn : res.data.cards[i].vrn
//                                         }
//                     cards.push(card);
//                 }
//                 setState(prevState => {
//                     return {
//                         ...prevState,
//                         cards: {
//                             title: "Shell Cards",
//                             items: cards
//                         }
//                     }
//                 })
//             })
//             .catch(console.error)
//             .finally(() => {
//                 setLoading(false)
//                 Swal.close();
//             });
//     }

//     function getVehicles(branchNumber) {

//         axiosConfig.post('Portal/GetAllVehicle', {
//              //"AccountNumber": "03339252999"
//         }, {
//             headers: headers
//         })
//             .then((res) => {
//                 let devices = []
//                 for (var i = 0; i < res.data.devices.length; i++) {
//                     let device = {
//                         id: 'vrn-' + v4(),
//                         name: res.data.devices[i].vrn,
//                         driver: res.data.devices[i].primaryUsername
//                     }
//                     devices.push(device);
//                 }
//                 setState(prevState => {
//                     return {
//                         ...prevState,
//                         vrn: {
//                             title: "Vehicles",
//                             items: devices
//                         }
//                     }
//                 })
//             })
//             .catch(console.error)
//             .finally(() => {
//                 setLoading(false)
//             });
//     }

//     useEffect(() => {

//         setState(prevState => {
//             return {
//                 ...prevState,
//                 vrn: {
//                     title: "Vehicles",
//                     items: []
//                 },
//                 cards: {
//                     title: "Shell Cards",
//                     items: []
//                 },
//                 mapped: {
//                     title: "Create Combination",
//                     items: []
//                 }
//             }
//         })

//         Swal.fire({
//             title: 'Please Wait ...',
//             onBeforeOpen() {
//                 Swal.showLoading()
//             },
//             onAfterClose() {
//                 Swal.hideLoading()
//             },
//             allowOutsideClick: false,
//             allowEscapeKey: false,
//             allowEnterKey: false,
//             showCancelButton: false,
//             showConfirmButton: false
//         })
//         checkVRN = false;
//         checkPAN = false;
//         setSelectedBranchNumber(props.data.selectedBranchNumber);
//         setLoading(true);
//         getCards(props.data.selectedBranchId);
//         getVehicles(props.data.selectedBranchNumber);
//     }, [props.data.selectedBranchNumber, refreshMapping]);

//     const handleDragEnd = ({ destination, source, draggableId }) => {


//         console.log('Source: ' + source.droppableId  )
//         console.log('Destination: ' + destination.droppableId  )
      

//         if (destination != null) {
//             ;

//             let dragtype = draggableId.split("-");

//             console.log('DragType: ' + dragtype[0])

//             if (!destination || !source) {
//                 return
//             }

//             if (source.index === destination.index && source.droppableId === destination.droppableId) {
//                 return
//             }

//             if (destination.length > 2) {
//                 return (
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'Invalid Mapping',
//                         text: 'Only 2 allowed',
//                     })
//                 );
//             }

//             if ((source.droppableId === 'cards' && destination.droppableId === 'vrn') || (source.droppableId === 'vrn' && destination.droppableId === 'cards')) {
//                 return (
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'Invalid Mapping',
//                         text: 'Please Drag VRN / Card in the mapped list',
//                     })
//                 );
//             }

//             if (source.droppableId === 'vrn' && destination.droppableId != 'vrn') {
//                 if (!checkVRN) {
//                     checkVRN = true;
//                 }
//                 else {
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'VRN already Added',
//                         text: 'Only 1 VRN can be added at a time',
//                     })
//                     return
//                 }
//             }

//             if (source.droppableId === 'cards' && destination.droppableId != 'cards') {
//                 if (!checkPAN) {
//                     checkPAN = true;
//                 }
//                 else {
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'PAN already Added',
//                         text: 'Only 1 PAN can be added at a time',
//                     })
//                     return
//                 }
//             }

//             if (source.droppableId === 'mapped' && destination.droppableId === 'vrn') {
//                 if (dragtype[0] === 'vrn') {
//                     checkVRN = false;
//                 }
//                 else {
//                     return;
//                 }
//             }

//             if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
//                 if (dragtype[0] === 'card') {
//                     checkPAN = false;
//                 }
//                 else {
//                     return;
//                 }
//             }

//             if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
//                 if (dragtype[0] === 'vrn') {
//                     return;
//                 }
//             }

//             const itemCopy = { ...state[source.droppableId].items[source.index] }
//             // console.log("item to copy is now : ", itemCopy)

//             setState(prev => {

//                 prev = { ...prev }
//                 prev[source.droppableId].items.splice(source.index, 1)

//                 prev[destination.droppableId].items.splice(destination.index, 0, itemCopy)
//                 return prev
//             })


//             if (dragtype[0] === 'vrn') {
//                 let obj = state.vrn.items.find(o => o.id === draggableId);
//             }

//             if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
//                 setCounter(counter => counter - props.IncrementalFee);
//             }
//             else if(source.droppableId === 'cards' && destination.droppableId === 'mapped'){
//                 setCounter(counter => counter + props.IncrementalFee);
//             }
//         }
//     }

//     const addItem = () => {
//         setState(prev => {
//             return {
//                 ...prev,
//                 vrn: {
//                     title: "Devices",
//                     items: [
//                         {
//                             id: 'vrn-' + v4(),
//                             name: text
//                         },
//                         ...prev.vrn.items
//                     ]
//                 }
//             }
//         })

//         setText("")
//     }
//     return (

//         <DragDropContext onDragEnd={handleDragEnd}>
//             <Col>
//                 <CardDeck>
//                      {_.map(state, (data, key) => {
//                         return (

//                             <Card key={key} className="card p-3 text-center rounded"
//                                 style={{ boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
//                                 <Card.Title className="text-left">
//                                     {data.title}

//                                     {data.title == "Create Combination"
//                                         ?
                                     
                                 
                                    
//                                         // <div className="pull-right">
//                                         //     {/* <FeatherIcon icon="shopping-cart" size="25" />
//                                         //     <span class="notificationbadge badge badge-pill badge-danger">{"PKR " + counter}</span> */}
//                                         // </div>
//                                         <div style={{ marginBottom: 5 }}>

//                                         <small>Drag & drop a Shell Card & Vehicle to create a Combination</small>
//                                         {/* <p className="mb-0 header small-font" style={{fontWeight:'100',fontSize:'12px',Paddingleft:'2px',paddingTop:'5px'}}>{"Please drag vehicles here to make Vehicle Groups." }</p> */}

//                                     </div>
                                        
//                                         :
//                                         <div> </div>
                                       
//                                     }



//                                 </Card.Title>
//                                 <Droppable droppableId={key}>
//                                     {(provided, snapshot) => {
//                                         return (
//                                             <Card.Body
//                                                 ref={provided.innerRef}
//                                                 {...provided.droppableProps}
//                                                 style={{ height: '300px', overflowY: 'auto', scrollbarColor: 'yellowgreen' }}
//                                             >
//                                                 {data.items.map((el, index) => {
//                                                     return (
//                                                         <Draggable key={el.id} index={index} draggableId={el.id} origin="test">
//                                                             {(provided, snapshot) => {
//                                                                 return (
//                                                                     <div
//                                                                         className={`item ${snapshot.isDragging && "dragging"}`}
//                                                                         ref={provided.innerRef}
//                                                                         {...provided.draggableProps}
//                                                                         {...provided.dragHandleProps}
//                                                                     >
//                                                                         <div className="box-item btn btn-default w-100">
//                                                                             {/* {el.driver != null ?

//                                                                                 <><small className="pull-left">{el.driver}</small><br /><small className="pull-right">{el.name}</small></>


//                                                                                 :

//                                                                                 <small>{el.name}</small>

//                                                                             } */}
//                                                                             {(el.driver != null && el.driver != '.' && el.driver != ' ') ?
                                                                                    
//                                                                                     // mask the remaining numbers with asterisks
                                                                                                                                                                
                                                                                                                                                                      
//                                                                                     <><small className="pull-left">{el.driver}</small><br/>
//                                                                                       <small className="pull-right">{el.name}</small></>
                                                                                                                                                                    
                                                                                                                                                                   
//                                                                                             :
                                                                                                                                                                   
//                                                                                     <><small className="pull-left">{el.vrn}</small><br/>
//                                                                                       <small className="pull-right">{el.name}</small></>
                                                                                                                                                                   
//                                                                             }

//                                                                         </div>
//                                                                     </div>
//                                                                 )
//                                                             }}
//                                                         </Draggable>
//                                                     )
//                                                 })}
//                                                 {provided.placeholder}

//                                             </Card.Body>
//                                         )
//                                     }}
//                                 </Droppable>
//                                 {state.vrn.items && 
                                
//                                 <MapButton 
//                                     BoxName={data.title} 
//                                     mappedData={state.mapped.items} 
//                                     selectedBranchID={selectedBranchID} 
//                                     userID={props.data.userID}
//                                     onMapResult={clearMapping}
//                                 />
//                                 }
//                             </Card>

//                         )
//                     })}
//                 </CardDeck>
//             </Col>
//         </DragDropContext>
//     );
// }

// export default DND;
// Previous code commented above
// New Code is written as being given below
import React, { useState, useEffect, useLayoutEffect } from 'react'
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
import _ from "lodash"
import { v4 } from "uuid"
import Swal from 'sweetalert2'
import axiosConfig from '../config/axiosConfig'
import { Card, CardDeck, Row, Col, Accordion, Button,Form} from 'react-bootstrap'
import BoxItemDropDown from '../components/BoxItemDropDown'
import FeatherIcon from 'feather-icons-react';
import Select from 'react-select';



var checkVRN = false;
var checkPAN = false;

const headers = {
    'Content-Type': 'application/json',
    'APIkey': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
}

function MapButton(props) {
    const BoxName = props.BoxName;


    if (BoxName === 'Create Combination') {
        return (

            <Card.Footer>
                <Button className="w-35"
                    variant="shell"
                    onClick={() => mapCardsAPI(props)}
                >
                    Save Combination</Button>
            </Card.Footer>
        )
    }
    return (
        <>
        </>
    )
}

function mapCardsAPI(props) {

    debugger
    console.log('here safee')

    let VRN = ""
    let Cards = []
    props.mappedData.map((el, index) => {
        let type = el.id.split("-")
        if (type[0] === 'card')
            Cards.push(el.name)
        else if (type[0] === 'vrn')
            VRN = el.name
    })
    
    if(VRN != '')
    {
    axiosConfig.post('Portal/CardMapping', {
        "UserBranchID": props.selectedBranchID,
        "VRN": VRN,
        "Cards": Cards
    })
        .then((res) => {
            debugger
            console.log(res.data)
            if(res.data.responsecode = '00')
            {
            Swal.fire({
                icon: 'success',
                title: 'Card Mapping Submitted',
                text: res.data.status.description,
                position: 'top-end',
                timer: 1500
            })

            setTimeout(function() {
                props.onMapResult("Clear Mapping Data")
            }, 1500);
            localStorage.setItem('tabClosed', 'false');
         window.location.reload();
        }
        else
        {
            Swal.fire({
                title: "Something Went Wrong",
                text: res.data.description,
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        }
            
        })
        .catch(function (error) {
            Swal.fire({
                title: "Something Went Wrong",
                text: error.response.data.errorMessage,
                icon: 'error',
                confirmButtonText: 'Okay'
            })
        })
        .finally(() => {
            //DND(props)
            checkVRN = false
            checkPAN = false
        });
    }
    else 
    {
        Swal.fire({
            title: "Please select combination",
            text: "Please select VRN and CARD",
            icon: 'error',
            confirmButtonText: 'Okay'
        })
    }

};
// function mapCardsAPI(props) {


//     console.log('here safee')

//     let VRN = ""
//     let Cards = []
//     props.mappedData.map((el, index) => {
//         let type = el.id.split("-")
//         if (type[0] === 'card')
//             Cards.push(el.name)
//         else if (type[0] === 'vrn')
//             VRN = el.name
//     })

//     axiosConfig.post('Portal/CardMapping', {
//         "UserBranchID": props.selectedBranchID,
//         "VRN": VRN,
//         "Cards": Cards
//     })
//         .then((res) => {
//             console.log(res.data)
//             Swal.fire({
//                 icon: 'success',
//                 title: 'Card Mapping Submitted',
//                 text: res.data.status.description,
//                 position: 'top-end',
//                 timer: 1500
//             })

//             setTimeout(function() {
//                 props.onMapResult("Clear Mapping Data")
//             }, 1500);

            
//         })
//         .catch(function (error) {
//             Swal.fire({
//                 title: "Something Went Wrong",
//                 text: error.response.data.errorMessage,
//                 icon: 'error',
//                 confirmButtonText: 'Okay'
//             })
//         })
//         .finally(() => {
//             //DND(props)
//             checkVRN = false
//             checkPAN = false
//         });

// };

function DND(props) {
    const [totalVRN, setTotalVRN] = useState(0)
    const [refreshMapping, setRefreshMapping] = useState(0)
    const [counter, setCounter] = useState(props.TotalFee)
    const [loading, setLoading] = useState(false);
    const [UserData, setUserData] = useState([]);
    const [selectedBranchID, setSelectedBranchID] = useState(props.data.selectedBranchId)
    const [selectedBranchNumber, setSelectedBranchNumber] = useState(props.data.selectedBranchNumber)

    const Swal = require('sweetalert2')
    const [text, setText] = useState("")
    const [state, setState] = useState({
        "vrn": {
            title: "Vehicles",
            items: []
        },
        "cards": {
            title: "Shell Cards",
            items: []
        },
        "mapped": {
            title: "Create Combination",
            items: []
        }
    })


    const [selectedCard, setSelectedCard] = useState(null);
    const [selectedVRN, setSelectedVRN] = useState(null);

    // ... (Other state variables and useEffect)

    const handleCardSelect = (selectedOption) => {
        setSelectedCard(selectedOption);
    };

    const handleVRNSelect = (selectedOption) => {
        setSelectedVRN(selectedOption);
    };

    const handleSaveCombination = () => {
        if (selectedCard && selectedVRN) {
            // const mappedData = [
            //     ...state.mapped.items,
            //     { id: `card-${v4()}`, name: selectedCard.label, driver: selectedCard.driver },
            //     { id: `vrn-${v4()}`, name: selectedVRN.label, driver: selectedVRN.driver }
            // ];

            // setState((prevState) => ({
            //     ...prevState,
            //     mapped: {
            //         title: 'Create Combination',
            //         items: mappedData
            //     }
            // }));

            // setSelectedCard(null);
            // setSelectedVRN(null);

            // ... (Rest of the code for saving combination)

            debugger
            console.log('here safee')
        
            let VRN = ""
            let Cards = []
                    Cards.push(selectedCard.value)
                    VRN = selectedVRN.value
            
            
            if(VRN != '')
            {
            axiosConfig.post('Portal/CardMapping', {
                "UserBranchID": selectedBranchID,
                "VRN": VRN,
                "Cards": Cards
            })
                .then((res) => {
                    debugger
                    console.log(res.data)
                    if(res.data.responsecode = '00')
                    {
                    Swal.fire({
                        icon: 'success',
                        title: 'Card Mapping Submitted',
                        text: res.data.status.description,
                        position: 'top-end',
                        timer: 1500
                    })
        
                    setTimeout(function() {
                        props.onMapResult("Clear Mapping Data")
                    }, 1500);
                    localStorage.setItem('tabClosed', 'false');
                 window.location.reload();
                }
                else
                {
                    Swal.fire({
                        title: "Something Went Wrong",
                        text: res.data.description,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                }
                    
                })
                .catch(function (error) {
                    Swal.fire({
                        title: "Something Went Wrong",
                        text: error.response.data.errorMessage,
                        icon: 'error',
                        confirmButtonText: 'Okay'
                    })
                })
                .finally(() => {
                    //DND(props)
                    checkVRN = false
                    checkPAN = false
                });
            }
            else 
            {
                Swal.fire({
                    title: "Please select combination",
                    text: "Please select VRN and CARD",
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            }
        
        } else {
            Swal.fire({
                title: 'Please select combination',
                text: 'Please select both a VRN and a Card',
                icon: 'error',
                confirmButtonText: 'Okay'
            });
        }
    };

  

    function clearMapping(data){

        setState(prevState => {
            return {
                ...prevState,
                "mapped": {
                    title: "Create Combination",
                    items: []
                }
            }
        })

        setRefreshMapping(prevCount => prevCount + 1);
        props.refreshCardMapping(refreshMapping)
    }

    function getCards(branchID) {
        axiosConfig.post('Accounts/FetchAccountCards', {
            "UserBranchID": branchID
        }, {
            headers: headers
        })
            .then((res) => {
                let cards = []
                for (var i = 0; i < res.data.cards.length; i++) {
                    // let card = {
                    //     id: 'card-' + v4(),
                    //     name: res.data.cards[i].pan,
                    //     driver: res.data.cards[i].driverName
                    // }
                    var str = res.data.cards[i].pan;
                                        str = str.replace(str.substring(4,11), "****")
                                        let card = {
                                            id: 'card-' + v4(),
                                            //name: res.data.cards[i].pan,
                                            name: str,
                                            driver: res.data.cards[i].driverName, 
                                            vrn : res.data.cards[i].vrn
                                        }
                    cards.push(card);
                }
                setState(prevState => {
                    return {
                        ...prevState,
                        cards: {
                            title: "Shell Cards",
                            items: cards
                        }
                    }
                })
            })
            .catch(console.error)
            .finally(() => {
                setLoading(false)
                Swal.close();
            });
    }

    function getVehicles(branchNumber) {

        axiosConfig.post('Portal/GetAllVehicle', {
             //"AccountNumber": "03339252999"
        }, {
            headers: headers
        })
            .then((res) => {
                let devices = []
                for (var i = 0; i < res.data.devices.length; i++) {
                    let device = {
                        id: 'vrn-' + v4(),
                        name: res.data.devices[i].vrn,
                        driver: res.data.devices[i].primaryUsername
                    }
                    devices.push(device);
                }
                setState(prevState => {
                    return {
                        ...prevState,
                        vrn: {
                            title: "Vehicles",
                            items: devices
                        }
                    }
                })
            })
            .catch(console.error)
            .finally(() => {
                setLoading(false)
            });
    }

    useEffect(() => {

        setState(prevState => {
            return {
                ...prevState,
                vrn: {
                    title: "Vehicles",
                    items: []
                },
                cards: {
                    title: "Shell Cards",
                    items: []
                },
                mapped: {
                    title: "Create Combination",
                    items: []
                }
            }
        })

        Swal.fire({
            title: 'Please Wait ...',
            onBeforeOpen() {
                Swal.showLoading()
            },
            onAfterClose() {
                Swal.hideLoading()
            },
            allowOutsideClick: false,
            allowEscapeKey: false,
            allowEnterKey: false,
            showCancelButton: false,
            showConfirmButton: false
        })
        checkVRN = false;
        checkPAN = false;
        setSelectedBranchNumber(props.data.selectedBranchNumber);
        setLoading(true);
        getCards(props.data.selectedBranchId);
        getVehicles(props.data.selectedBranchNumber);
    }, [props.data.selectedBranchNumber, refreshMapping]);

    const handleDragEnd = ({ destination, source, draggableId }) => {


        console.log('Source: ' + source.droppableId  )
        console.log('Destination: ' + destination.droppableId  )
      

        if (destination != null) {
            ;

            let dragtype = draggableId.split("-");

            console.log('DragType: ' + dragtype[0])

            if (!destination || !source) {
                return
            }

            if (source.index === destination.index && source.droppableId === destination.droppableId) {
                return
            }

            if (destination.length > 2) {
                return (
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid Mapping',
                        text: 'Only 2 allowed',
                    })
                );
            }

            if ((source.droppableId === 'cards' && destination.droppableId === 'vrn') || (source.droppableId === 'vrn' && destination.droppableId === 'cards')) {
                return (
                    Swal.fire({
                        icon: 'error',
                        title: 'Invalid Mapping',
                        text: 'Please Drag VRN / Card in the mapped list',
                    })
                );
            }

            if (source.droppableId === 'vrn' && destination.droppableId != 'vrn') {
                if (!checkVRN) {
                    checkVRN = true;
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'VRN already Added',
                        text: 'Only 1 VRN can be added at a time',
                    })
                    return
                }
            }

            if (source.droppableId === 'cards' && destination.droppableId != 'cards') {
                if (!checkPAN) {
                    checkPAN = true;
                }
                else {
                    Swal.fire({
                        icon: 'error',
                        title: 'PAN already Added',
                        text: 'Only 1 PAN can be added at a time',
                    })
                    return
                }
            }

            if (source.droppableId === 'mapped' && destination.droppableId === 'vrn') {
                if (dragtype[0] === 'vrn') {
                    checkVRN = false;
                }
                else {
                    return;
                }
            }

            if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
                if (dragtype[0] === 'card') {
                    checkPAN = false;
                }
                else {
                    return;
                }
            }

            if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
                if (dragtype[0] === 'vrn') {
                    return;
                }
            }

            const itemCopy = { ...state[source.droppableId].items[source.index] }
            // console.log("item to copy is now : ", itemCopy)

            setState(prev => {

                prev = { ...prev }
                prev[source.droppableId].items.splice(source.index, 1)

                prev[destination.droppableId].items.splice(destination.index, 0, itemCopy)
                return prev
            })


            if (dragtype[0] === 'vrn') {
                let obj = state.vrn.items.find(o => o.id === draggableId);
            }

            if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
                setCounter(counter => counter - props.IncrementalFee);
            }
            else if(source.droppableId === 'cards' && destination.droppableId === 'mapped'){
                setCounter(counter => counter + props.IncrementalFee);
            }
        }
    }

    const addItem = () => {
        setState(prev => {
            return {
                ...prev,
                vrn: {
                    title: "Devices",
                    items: [
                        {
                            id: 'vrn-' + v4(),
                            name: text
                        },
                        ...prev.vrn.items
                    ]
                }
            }
        })

        setText("")
    }
    return (

        <DragDropContext onDragEnd={handleDragEnd}>
                        <Row className='mt-0' style={{width:'100%'}}>
                            <div className='col-md-12'>
                            <div className='card mb-0'>
                                <div className='card-title m-3' style={{fontWeight: '600'}}>Create Combination by Search</div>
                                <div className='card-body pt-0' style={{display: 'flex'}}>
                                <Col >
                    <Form.Group>
                        {/* <Form.Label>Select VRN:</Form.Label> */}
                        <div   style={{width:"380px"}}
>
                        <Select
                            value={selectedVRN}
                            onChange={handleVRNSelect}
                            options={state.vrn.items.map((vrn) => ({
                                value: vrn.name,
                                label: vrn.driver + "(" + vrn.name + ")",
                                driver: vrn.driver 
                            }))}
                            isSearchable
                            placeholder="Select a VRN"
                        />
                        </div>

                    </Form.Group>
                </Col>
                <Col >
                    <Form.Group>
                    {/* <Form.Label>Select Card:</Form.Label> */}
                        <div   style={{width:"380px"}}>

                        <Select
                            value={selectedCard}
                            onChange={handleCardSelect}
                            options={state.cards.items.map((card) => ({
                                value: card.name,
                                label: (card.driver != null && card.driver != '.' && card.driver != ' ') ? card.driver + "(" +card.name + ")" : card.vrn + "(" +card.name + ")",
                                driver: card.driver
                            }))}
                            isSearchable
                            placeholder="Select a Card"
                        />
                        </div>
                        
                    </Form.Group>
                </Col>
                <Col>
                    <Form.Group>
                        <Form.Label>&nbsp;</Form.Label>
                        <div>
                        <Button variant="warning" onClick={handleSaveCombination}>
                            Save Combination
                        </Button>
                        </div>
                    </Form.Group>
                </Col>
                                </div>
                            </div>
                            </div>
            </Row>
            <Row style={{width:'100%'}}>
                <div className='col-md-12'>
                    <div className='card'>
                        <div className='card-title m-3' style={{fontWeight: '600'}}>Create Combination by Drag & Drop</div>
                        <div className='card-body pt-0'>
                        <Col>
                <CardDeck>
                                       

                     {_.map(state, (data, key) => {
                        return (

                            <Card key={key} className="card p-3 text-center rounded"
                                style={{ boxShadow: "0px 0px 10px 2px rgba(64, 64, 64, 0.3)" }}>
                                <Card.Title className="text-left">
                                    {data.title}

                                    {data.title == "Create Combination"
                                        ?
                                     
                                 
                                    
                                        // <div className="pull-right">
                                        //     {/* <FeatherIcon icon="shopping-cart" size="25" />
                                        //     <span class="notificationbadge badge badge-pill badge-danger">{"PKR " + counter}</span> */}
                                        // </div>
                                        <div style={{ marginBottom: 5 }}>

                                        <small>Drag & drop a Shell Card & Vehicle to create a Combination</small>
                                        {/* <p className="mb-0 header small-font" style={{fontWeight:'100',fontSize:'12px',Paddingleft:'2px',paddingTop:'5px'}}>{"Please drag vehicles here to make Vehicle Groups." }</p> */}

                                    </div>
                                        
                                        :
                                        <div> </div>
                                       
                                    }



                                </Card.Title>
                                <Droppable droppableId={key}>
                                    {(provided, snapshot) => {
                                        return (
                                            <Card.Body
                                                ref={provided.innerRef}
                                                {...provided.droppableProps}
                                                style={{ height: '300px', overflowY: 'auto', scrollbarColor: 'yellowgreen' }}
                                            >
                                                {data.items.map((el, index) => {
                                                    return (
                                                        <Draggable key={el.id} index={index} draggableId={el.id} origin="test">
                                                            {(provided, snapshot) => {
                                                                return (
                                                                    <div
                                                                        className={`item ${snapshot.isDragging && "dragging"}`}
                                                                        ref={provided.innerRef}
                                                                        {...provided.draggableProps}
                                                                        {...provided.dragHandleProps}
                                                                    >
                                                                        <div className="box-item btn btn-default w-100">
                                                                            {/* {el.driver != null ?

                                                                                <><small className="pull-left">{el.driver}</small><br /><small className="pull-right">{el.name}</small></>


                                                                                :

                                                                                <small>{el.name}</small>

                                                                            } */}
                                                                            {(el.driver != null && el.driver != '.' && el.driver != ' ') ?
                                                                                    
                                                                                    // mask the remaining numbers with asterisks
                                                                                                                                                                
                                                                                                                                                                      
                                                                                    <><small className="pull-left">{el.driver}</small><br/>
                                                                                      <small className="pull-right">{el.name}</small></>
                                                                                                                                                                    
                                                                                                                                                                   
                                                                                            :
                                                                                                                                                                   
                                                                                    <><small className="pull-left">{el.vrn}</small><br/>
                                                                                      <small className="pull-right">{el.name}</small></>
                                                                                                                                                                   
                                                                            }

                                                                        </div>
                                                                    </div>
                                                                )
                                                            }}
                                                        </Draggable>
                                                    )
                                                })}
                                                {provided.placeholder}

                                            </Card.Body>
                                        )
                                    }}
                                </Droppable>
                                {state.vrn.items && 
                                
                                <MapButton 
                                    BoxName={data.title} 
                                    mappedData={state.mapped.items} 
                                    selectedBranchID={selectedBranchID} 
                                    userID={props.data.userID}
                                    onMapResult={clearMapping}
                                />
                                }
                            </Card>

                        )
                    })}
                </CardDeck>
            </Col>
                        </div>
                    </div>
                </div>
           
            </Row>
        </DragDropContext>
    );
}

export default DND;

//end of new code is written

//another previous code written for test

// import React, { useState, useEffect, useLayoutEffect } from 'react'
// import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd"
// import _ from "lodash"
// import { v4 } from "uuid"
// import Swal from 'sweetalert2'
// import axiosConfig from '../config/axiosConfig'
// import { Card, CardDeck, Row, Col, Accordion, Button } from 'react-bootstrap'
// import BoxItemDropDown from '../components/BoxItemDropDown'
// import FeatherIcon from 'feather-icons-react';
// import HeadingBox from '../components/HeadingBox';
// import HeadingDescBox from '../components/HeadingDescBox';


// var checkVRN = false;
// var checkPAN = false;

// const headers = {
//     'Content-Type': 'application/json',
//     'APIkey': 'C5BFF7F0-B4DF-475E-A331-F737424F013C',
// }

// function MapButton(props) {
//     const BoxName = props.BoxName;


//     if (BoxName === 'Create Combination') {
//         return (

//             <Card.Footer>
//                 <Button className="w-35"
//                     variant="shell"
//                     onClick={() => mapCardsAPI(props)}
//                 >
//                     Save Combination</Button>
//             </Card.Footer>
//         )
//     }
//     return (
//         <>
//         </>
//     )
// }


// function mapCardsAPI(props) {


//     console.log('here safee')

//     let VRN = ""
//     let Cards = []
//     props.mappedData.map((el, index) => {
//         let type = el.id.split("-")
//         if (type[0] === 'card')
//             Cards.push(el.name)
//         else if (type[0] === 'vrn')
//             VRN = el.name
//     })

//     axiosConfig.post('Portal/CardMapping', {
//         "UserBranchID": props.selectedBranchID,
//         "VRN": VRN,
//         "Cards": Cards
//     })
//         .then((res) => {
//             console.log(res.data)
//             Swal.fire({
//                 icon: 'success',
//                 title: 'Card Mapping Submitted',
//                 text: res.data.status.description,
//                 position: 'top-end',
//                 timer: 1500
//             })

//             setTimeout(function() {
//                 props.onMapResult("Clear Mapping Data")
//             }, 1500);
//          window.location.reload();
            
//         })
//         .catch(function (error) {
//             Swal.fire({
//                 title: "Something Went Wrong",
//                 text: error.response.data.errorMessage,
//                 icon: 'error',
//                 confirmButtonText: 'Okay'
//             })
//         })
//         .finally(() => {
//             //DND(props)
//             checkVRN = false
//             checkPAN = false
//         });

// };

// function DND(props) {
    
//     const [totalVRN, setTotalVRN] = useState(0)
//     const [refreshMapping, setRefreshMapping] = useState(0)
//     const [counter, setCounter] = useState(props.TotalFee)
//     const [loading, setLoading] = useState(false);
//     const [UserData, setUserData] = useState([]);
//     const [selectedBranchID, setSelectedBranchID] = useState(props.data.selectedBranchId)
//     const [selectedBranchNumber, setSelectedBranchNumber] = useState(props.data.selectedBranchNumber)

//     const Swal = require('sweetalert2')
//     const [text, setText] = useState("")
//     const [state, setState] = useState({
//         "vrn": {
//             title: "Vehicles",
//             items: []
//         },
//         "cards": {
//             title: "Shell Cards",
//             items: []
//         },
//         "mapped": {
//             title: "Create Combination",
//             items: []
//         }
//     })

//     const [filteredItems, setFilteredItems] = useState({
//         vrn: {
//           title: "Vehicles",
//           items: []
//         },
//         cards: {
//           title: "Shell Cards",
//           items: []
//         },
//         mapped: {
//           title: "Create Combination",
//           items: []
//         }
//       });
      
//       const handleSearchFilter = (event) => {
//         debugger
//         const searchText = event.target.value.toLowerCase();
      
//         const filteredVRNItems = state.vrn.items.filter((item) =>
//           //item.name.toLowerCase().includes(searchText)
//           searchText === '' || item.name.toLowerCase().includes(searchText.toLowerCase())
//           //searchText ? item.name.toLowerCase().includes(searchText.toLowerCase()) : item
//         );
      
//         const filteredCardsItems = state.cards.items.filter((item) =>
//           //item.name.toLowerCase().includes(searchText)
//           searchText === '' || item.name.toLowerCase().includes(searchText.toLowerCase())
//           //searchText ? item.name.toLowerCase().includes(searchText.toLowerCase()) : item
//         );
      
//         setFilteredItems({
//           vrn: {
//             title: "Vehicles",
//             items: filteredVRNItems
//           },
//           cards: {
//             title: "Shell Cards",
//             items: filteredCardsItems
//           },
//           mapped: {
//             title: "Create Combination",
//             items: state.mapped.items
//           }
//         });
//       };
      
//     function clearMapping(data){
//        debugger
//         setState(prevState => {
//             return {
//                 ...prevState,
//                 "mapped": {
//                     title: "Create Combination",
//                     items: []
//                 }
//             }
//         })

//         setRefreshMapping(prevCount => prevCount + 1);
//         //setRefreshMapping(prevCount => prevCount);
//         props.refreshCardMapping(refreshMapping)
//     }

//     function getCards(branchID) {
//         axiosConfig.post('Accounts/FetchAccountCards', {
//             "UserBranchID": branchID
//         }, {
//             headers: headers
//         })
//             .then((res) => {
//                 let cards = []
//                 for (var i = 0; i < res.data.cards.length; i++) {
//                    var str = res.data.cards[i].pan;
//                     str = str.replace(str.substring(6,15), "******")
//                     let card = {
//                         id: 'card-' + v4(),
//                         //name: res.data.cards[i].pan,
//                         name: str,
//                         driver: res.data.cards[i].driverName, 
//                         vrn : res.data.cards[i].vrn
//                     }
//                     cards.push(card);
//                 }
//                 setState(prevState => {
//                     return {
//                         ...prevState,
//                         cards: {
//                             title: "Shell Cards",
//                             items: cards
//                         }
//                     }
//                 })
//             })
//             .catch(console.error)
//             .finally(() => {
//                 setLoading(false)
//                 Swal.close();
//             });
//     }

//     function getVehicles(branchNumber) {

//         axiosConfig.post('Portal/GetAllVehicle', {
//              //"AccountNumber": "03339252999"
//         }, {
//             headers: headers
//         })
//             .then((res) => {
//                 let devices = []
//                 for (var i = 0; i < res.data.devices.length; i++) {
//                     let device = {
//                         id: 'vrn-' + v4(),
//                         name: res.data.devices[i].vrn,
//                         driver: res.data.devices[i].primaryUsername
//                     }
//                     devices.push(device);
//                 }
//                 setState(prevState => {
//                     return {
//                         ...prevState,
//                         vrn: {
//                             title: "Vehicles",
//                             items: devices
//                         }
//                     }
//                 })
//             })
//             .catch(console.error)
//             .finally(() => {
//                 setLoading(false)
//             });
//     }


   

//     useEffect(() => {

//         setState(prevState => {
//             return {
//                 ...prevState,
//                 vrn: {
//                     title: "Vehicles",
//                     items: []
//                 },
//                 cards: {
//                     title: "Shell Cards",
//                     items: []
//                 },
//                 mapped: {
//                     title: "Create Combination",
//                     items: []
//                 }
//             }
//         })

//         Swal.fire({
//             title: 'Please Wait ...',
//             onBeforeOpen() {
//                 Swal.showLoading()
//             },
//             onAfterClose() {
//                 Swal.hideLoading()
//             },
//             allowOutsideClick: false,
//             allowEscapeKey: false,
//             allowEnterKey: false,
//             showCancelButton: false,
//             showConfirmButton: false
//         })
//         checkVRN = false;
//         checkPAN = false;
//         setSelectedBranchNumber(props.data.selectedBranchNumber);
//         setLoading(true);
//         getCards(props.data.selectedBranchId);
//         getVehicles(props.data.selectedBranchNumber);

     
        
      
//     }, [props.data.selectedBranchNumber, refreshMapping]);

   
    

//     const handleDragEnd = ({ destination, source, draggableId }) => {


//         console.log('Source: ' + source.droppableId  )
//         console.log('Destination: ' + destination.droppableId  )
      

//         if (destination != null) {
//             ;

//             let dragtype = draggableId.split("-");

//             console.log('DragType: ' + dragtype[0])

//             if (!destination || !source) {
//                 return
//             }

//             if (source.index === destination.index && source.droppableId === destination.droppableId) {
//                 return
//             }

//             if (destination.length > 2) {
//                 return (
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'Invalid Mapping',
//                         text: 'Only 2 allowed',
//                     })
//                 );
//             }

//             if ((source.droppableId === 'cards' && destination.droppableId === 'vrn') || (source.droppableId === 'vrn' && destination.droppableId === 'cards')) {
//                 return (
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'Invalid Mapping',
//                         text: 'Please Drag VRN / Card in the mapped list',
//                     })
//                 );
//             }

//             if ((destination.droppableId === 'cards' && source.droppableId != 'vrn' && source.droppableId != 'cards') || (destination.droppableId === 'vrn' && source.droppableId != 'vrn' && source.droppableId != 'cards') ) {
//                 // return (
//                 //     Swal.fire({
//                 //         icon: 'error',
//                 //         title: 'Invalid Mapping',
//                 //         text: 'Please donot Drag VRN / Card from mapped list',
//                 //     })
//                 // );
//                 //window.location.reload();
//                 getCards(props.data.selectedBranchId);
//                 getVehicles(props.data.selectedBranchId);
//             }

//             if (source.droppableId === 'vrn' && destination.droppableId != 'vrn') {
//                 if (!checkVRN) {
//                     checkVRN = true;
//                 }
//                 else {
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'VRN already Added',
//                         text: 'Only 1 VRN can be added at a time',
//                     })
//                     return
//                 }
//             }

//             if (source.droppableId === 'cards' && destination.droppableId != 'cards') {
//                 if (!checkPAN) {
//                     checkPAN = true;
//                 }
//                 else {
//                     Swal.fire({
//                         icon: 'error',
//                         title: 'PAN already Added',
//                         text: 'Only 1 PAN can be added at a time',
//                     })
//                     return
//                 }
//             }

//             if (source.droppableId === 'mapped' && destination.droppableId === 'vrn') {
//                 if (dragtype[0] === 'vrn') {
//                     checkVRN = false;
//                 }
//                 else {
//                     return;
//                 }
//             }

//             if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
//                 if (dragtype[0] === 'card') {
//                     checkPAN = false;
//                 }
//                 else {
//                     return;
//                 }
//             }

//             if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
//                 if (dragtype[0] === 'vrn') {
//                     return;
//                 }
//             }

//             const itemCopy = { ...state[source.droppableId].items[source.index] }
//             // console.log("item to copy is now : ", itemCopy)

//             setState(prev => {

//                 prev = { ...prev }
//                 prev[source.droppableId].items.splice(source.index, 1)

//                 prev[destination.droppableId].items.splice(destination.index, 0, itemCopy)
//                 return prev
//             })


//             if (dragtype[0] === 'vrn') {
//                 let obj = state.vrn.items.find(o => o.id === draggableId);
//             }

//             if (source.droppableId === 'mapped' && destination.droppableId === 'cards') {
//                 setCounter(counter => counter - props.IncrementalFee);
//             }
//             else if(source.droppableId === 'cards' && destination.droppableId === 'mapped'){
//                 setCounter(counter => counter + props.IncrementalFee);
//             }
//         }
       
//     }
 
    
//     const addItem = () => {
//         setState(prev => {
//             return {
//                 ...prev,
//                 vrn: {
//                     title: "Devices",
//                     items: [
//                         {
//                             id: 'vrn-' + v4(),
//                             name: text
//                         },
//                         ...prev.vrn.items
//                     ]
//                 }
//             }
//         })

//         setText("")
//     }
//     return (
       

//         <DragDropContext onDragEnd={handleDragEnd}>
//             <Col>
            
//             <input
//   type="text"
 
//   placeholder="Search..."
//   onChange={handleSearchFilter}
//   style={{ marginBottom: '1rem' }}
// />
//                 <CardDeck>

//                     {_.map(state, (data, key) => {
//                         return (

//                             <Card key={key} className="card p-3 text-center rounded"
//                                 style={{ boxShadow: '0px 0px 10px 2px rgba(64, 64, 64, 0.3)' }}>
//                                 <Card.Title className="text-left">
//                                     {data.title}

//                                     {data.title == "Create Combination"
//                                         ?
//                                         //<HeadingDescBox  title="Drag & drop a Shell Card & Vehicle to create a Combination" />
//                                         // <p className="mb-0 header small-font" style={{fontWeight:'100',fontSize:'12px',Paddingleft:'2px',paddingTop:'5px'}}>{"Drag & drop a Shell Card & Vehicle to create a Combination" }</p>
//                                         <div style={{ marginBottom: 5 }}>

//                                         <small>Drag & drop a Shell Card & Vehicle to create a Combination</small>
//                                         {/* <p className="mb-0 header small-font" style={{fontWeight:'100',fontSize:'12px',Paddingleft:'2px',paddingTop:'5px'}}>{"Please drag vehicles here to make Vehicle Groups." }</p> */}

//                                     </div>
                                                
                                    
//                                         /*<div className="pull-right">
//                                             <FeatherIcon icon="shopping-cart" size="25" />
//                                             <span class="notificationbadge badge badge-pill badge-danger">{"PKR " + counter}</span>
//                                         </div>*/
//                                          :
//                                         <div> </div>
//                                     }



//                                 </Card.Title>
//                                 <Droppable droppableId={key}>
//                                     {(provided, snapshot) => {
//                                         return (
//                                             <Card.Body
//                                             ref={provided.innerRef}
//                                             {...provided.droppableProps}
//                                             style={{ height: '300px', overflowY: 'auto', scrollbarColor: 'yellowgreen' }}
//                                           >
//                                             {filteredItems[key].items.map((el, index) => {
//                                                     return (
//                                                         <Draggable key={el.id} index={index} draggableId={el.id} origin="test">
//                                                             {(provided, snapshot) => {
//                                                                 return (
//                                                                     <div
//                                                                         className={`item ${snapshot.isDragging && "dragging"}`}
//                                                                         ref={provided.innerRef}
//                                                                         {...provided.draggableProps}
//                                                                         {...provided.dragHandleProps}
//                                                                     >
//                                                                         <div className="box-item btn btn-default w-100">
//                                                                             {(el.driver != null && el.driver != '.' && el.driver != ' ') ?
                                                                                    
//                                                                                     // mask the remaining numbers with asterisks
                                                                            
                                                                                  
//                                                                                 <><small className="pull-left">{el.driver}</small><br/>
//                                                                                  <small className="pull-right">{el.name}</small></>
                                                                                
                                                                               
//                                                                                 :
                                                                               
//                                                                                 <><small className="pull-left">{el.vrn}</small><br/>
//                                                                                 <small className="pull-right">{el.name}</small></>
                                                                               
//                                                                             }

//                                                                         </div>
//                                                                     </div>
//                                                                 )
//                                                             }}
//                                                         </Draggable>
//                                                     )
//                                                 })}
//                                                 {provided.placeholder}

//                                             </Card.Body>
//                                         )
//                                     }}
//                                 </Droppable>
//                                 {state.vrn.items && 
                                
//                                 <MapButton 
//                                     BoxName={data.title} 
//                                     mappedData={state.mapped.items} 
//                                     selectedBranchID={selectedBranchID} 
//                                     userID={props.data.userID}
//                                     onMapResult={clearMapping}
//                                 />
//                                 }
//                             </Card>

//                         )
//                     })}
//                 </CardDeck>
//             </Col>
//         </DragDropContext>
//     );
// }

// export default DND;






